import React from "react";
import NavBar from "../Utils/NavBar";
import FootBar from "../Utils/FootBar";
import { useState, useEffect } from "react";
import { useParams } from "react-router";
import axios from "axios";
import { FaYoutube } from "react-icons/fa";
require("../../assets/stylesheets/History/Feria.css");
const doc2021_3 = require("../../assets/docs/Feria_2021-3.pdf");
const doc2022_1 = require("../../assets/docs/Feria_2022-1.pdf");
const doc2022_2 = require("../../assets/docs/Feria_2022-2.pdf");
var file = "";

function RowsMemory({ data }) {
  return (
    <div className="row" key={data.title}>
      <span id="titleMemorie">{data.title}</span>
      <span id="categoryMemorie">{data.categoryName}</span>
      <span id="likesMemorie">{data.likes}</span>
      <a href={`https://youtu.be/${data.code}`} target="_blank">
        <div className="btnYoutube">
          Ver en <FaYoutube className="youtube" />
        </div>
      </a>
    </div>
  );
}

function Memories() {
  const [dataEvent, setDataEvent] = useState([]);
  const params = useParams();

  useEffect(() => {
    axios
      .post("https://ferias-ingenio-backend.vercel.app/api/history/gethistory", { event: params.event })
      .then((res) => {
        setDataEvent(res.data);
        file = res.data[0].event;
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const Rows = Object.values(dataEvent).map((memorie) => {
    return <RowsMemory data={memorie} />;
  });

  return <div>{Rows}</div>;
}

function Feria() {
  const params = useParams();

  const FeriaFile = () => {
    if(file == '2021-3'){
      window.open(doc2021_3, '_blank');
      console.log(file);
    }
    if(file == '2022-1'){
      window.open(doc2022_1, '_blank');
    }
    if(file == '2022-2'){
      window.open(doc2022_2, '_blank');
    }
  }

  return (
    <div className="main">
      <NavBar />
      <h2 className="memoryTitle">Memorias del {params.event}</h2>
      <div className="inSection" id="inSection">
        <div className="row" id="headerMemories">
          <span id="titleMemorie">Titulo</span>
          <span id="categoryMemorie">Categoria</span>
          <span id="likesMemorie">Votos</span>
          <a onClick={FeriaFile}>
        <div className="btnDownload">
          Resultados
        </div>
      </a>
        </div>
        <Memories />
      </div>
    </div>
  );
}

export default Feria;
